module.exports = __webpack_public_path__ + "static/media/Loader.5fe4039b.gif";